import type { ContractorTranslation } from './en';

export const fr: ContractorTranslation = {
  common: {
    cancel: 'Annuler',
    save: 'Enregistrer',
    retry: 'Réessayer',
    download: 'Télécharger',
    continue: 'Continuer',
    yes: 'Oui',
    no: 'Non',
    genericError: "Une erreur s'est produite. Veuillez réessayer.",
    networkError: 'Impossible de joindre DubForge. Vérifiez votre connexion Internet.',
  },
  app: {
    tagline: 'Missions de doublage, fichiers et vérifications au même endroit.',
    startupFailed: "DubForge n'a pas pu démarrer",
    notFoundTitle: 'Page introuvable',
    notFoundBody: "Cette page n'existe pas ou vous n'y avez pas accès.",
    goHome: "Retour à l'accueil",
    crashTitle: "Une erreur s'est produite",
    crashBody: 'Essayez de recharger la page.',
    reload: 'Recharger',
  },
  language: {
    label: 'Langue',
    change: 'Changer de langue',
  },
  welcome: {
    title: 'Bienvenue sur DubForge',
    body: "Choisissez votre langue. DubForge et vos notifications Discord l'utiliseront.",
    changeLater: 'Vous pourrez la modifier à tout moment depuis le menu des langues, en haut à droite.',
  },
  nav: {
    myAssignments: 'Mes missions',
    openMenu: 'Ouvrir le menu',
    account: 'Compte',
    notificationEmail: 'E-mail de notification',
    signOut: 'Se déconnecter',
    roleAdmin: 'Administration',
    roleContractor: 'Doublage',
    lightMode: 'Mode clair',
    darkMode: 'Mode sombre',
  },
  login: {
    signIn: 'Se connecter avec Discord',
    onlyInvited: 'Seuls les comptes Discord ajoutés par le propriétaire de la chaîne peuvent se connecter.',
    signingIn: 'Connexion en cours…',
    backToSignIn: 'Retour à la connexion',
    failed: 'La connexion a échoué. Veuillez réessayer.',
  },
  authErrors: {
    not_invited:
      "Ce compte Discord n'a pas été ajouté à DubForge. Demandez au propriétaire de la chaîne de vous ajouter.",
    access_off: 'Votre accès à DubForge a été désactivé.',
    discord_only: "Vous ne pouvez vous connecter qu'avec Discord.",
  },
  errors: {
    not_signed_in: 'Votre session a expiré. Veuillez vous reconnecter.',
    access_off: 'Votre accès à DubForge a été désactivé.',
    admins_only: "Vous n'avez pas l'autorisation de faire cela.",
    not_found: "Cet élément n'existe pas ou n'est plus disponible.",
    invalid_request: "Un élément de la demande n'est pas valide. Vérifiez et réessayez.",
    conflict: 'Cet élément existe déjà.',
    already_approved: "Cette mission a déjà été approuvée : aucun autre envoi n'est nécessaire.",
    not_audio: 'Seuls les fichiers WAV ou MP3 sont acceptés. Envoyez uniquement votre piste vocale.',
    upload_incomplete: "L'envoi n'a pas abouti. Veuillez réessayer.",
    discord_unreachable: 'Impossible de joindre Discord. Veuillez réessayer plus tard.',
    server_error: "Une erreur s'est produite de notre côté. Veuillez réessayer.",
  },
  notifications: {
    title: 'Notifications',
    openWithCount: 'Notifications ({{count}} non lues)',
    markAllRead: 'Tout marquer comme lu',
    empty: 'Rien pour le moment.',
  },
  emailSettings: {
    body: 'Nous vous envoyons un e-mail quand une nouvelle mission vous est confiée et quand votre travail a été vérifié.',
    label: 'Adresse e-mail',
    fromDiscord: 'Récupérée depuis votre compte Discord. Modifiez-la si vous préférez une autre adresse.',
    saved: 'Adresse e-mail enregistrée',
    invalid: 'Saisissez une adresse e-mail valide.',
    missing: 'Aucune adresse e-mail pour le moment. Ajoutez-en une pour recevoir les notifications.',
  },
  status: {
    Assigned: 'Attribuée',
    InProgress: 'En cours',
    Submitted: 'En attente de vérification',
    ChangesRequested: 'Modifications demandées',
    Approved: 'Approuvée',
  },
  assetKind: {
    package: 'Pack de doublage (vidéo + voix + SFX)',
    video: 'Vidéo de référence (720p)',
    sfx: 'Piste SFX / musique',
    voice: 'Piste vocale originale',
    script: 'Script',
    other: 'Autre',
  },
  translation: {
    machine: 'Traduction automatique',
    showOriginal: "Voir l'original",
    showTranslation: 'Voir la traduction',
  },
  uploader: {
    progress: '{{percent}} % de {{size}}',
    queued: "En attente d'envoi : {{count}}",
    keepOpen: "Gardez cet onglet ouvert jusqu'à la fin.",
    cancelled: 'Envoi annulé',
    done: '{{name}} envoyé',
    failed: "Échec de l'envoi : {{error}}",
  },
  my: {
    greeting: 'Bonjour {{name}}',
    subtitle: 'Vos missions de doublage.',
    emptyTitle: 'Aucune mission pour le moment',
    emptyBody: 'Quand une vidéo vous sera confiée, vous recevrez un message sur Discord et elle apparaîtra ici.',
    todo: 'À faire',
    waiting: 'En attente de vérification',
    done: 'Terminées',
    updated: 'Mis à jour {{when}}',
  },
  assignment: {
    back: 'Mes missions',
    dubIn: 'Doublage : {{language}}',
    paid: 'Payé',
    next: {
      Assigned: 'Téléchargez les fichiers sources, enregistrez votre voix, puis envoyez votre piste vocale ici.',
      InProgress: 'Quand votre piste vocale est prête, envoyez-la ci-dessous.',
      Submitted:
        "Votre doublage a été envoyé pour vérification. Vous recevrez un message sur Discord une fois qu'il aura été vérifié.",
      ChangesRequested: 'Des modifications ont été demandées. Lisez les commentaires ci-dessous, puis envoyez une nouvelle version.',
      Approved: 'Approuvé. Merci !',
    },
    notes: 'Notes',
    sourceFiles: 'Fichiers sources',
    noFiles: "Aucun fichier n'a encore été envoyé.",
    fileInfo: '{{kind}} · {{size}}',
    packageHint: 'Un seul .mp4 avec la vidéo et deux pistes audio : la piste 1 contient les répliques originales, la piste 2 les SFX.',
    uploadTitle: 'Envoyez votre piste vocale',
    voiceOnlyTitle: 'Uniquement votre voix',
    voiceOnlyBody:
      "Envoyez uniquement votre voix enregistrée : pas de musique, pas d'effets sonores et rien de l'audio d'origine. Vérifiez qu'elle a la même durée que l'original.",
    voiceOnlyConfirm: 'Ce fichier contient uniquement les répliques enregistrées.',
    dropLabel: 'Envoyez votre piste vocale ici',
    dropHint: 'WAV ou MP3 uniquement.',
    noteForReviewer: 'Note pour la personne qui vérifie (facultatif)',
    lengthTitle: 'La durée ne correspond pas',
    lengthBody:
      "Votre fichier dure {{dub}}, mais la piste SFX dure {{sfx}}. Si votre piste commence à un autre moment ou est coupée, elle ne sera pas synchronisée avec la vidéo. L'envoyer quand même ?",
    uploadAnyway: 'Envoyer quand même',
    chooseAnother: 'Choisir un autre fichier',
    versions: 'Versions envoyées',
    nothingUploaded: "Rien n'a encore été envoyé.",
    version: 'Version {{version}}',
    reviewApproved: 'Approuvée',
    reviewChanges: 'Modifications demandées',
    reviewPending: 'En attente de vérification',
    yourNote: 'Votre note :',
    feedback: 'Commentaires',
    listen: 'Écouter',
    uploadedOn: '{{date}} · {{size}}',
    length: 'Durée : {{duration}}',
  },
};
